import { logUsage } from 'owa-analytics';
import { getSuggestions, lazySetIsSuggestionsDropdownVisible, startSearch } from 'owa-search';
import { orchestrator } from 'satcheljs';
import { setMaxEntries } from '../mutators/maxEntriesMutator';
import isFileSuggestionsSearchAction from '../utils/isFileSuggestionsSearchAction';
import { MAX_ENTRIES_DIRECTORY } from '../utils/searchConstants';

export default orchestrator(startSearch, async actionMessage => {
    const { scenarioId } = actionMessage;

    if (!isFileSuggestionsSearchAction(scenarioId)) {
        return;
    }
    // Log that a full search has been requested
    logUsage('InsertLinkFromSearchStartSearch');

    // Set the dropdown visibility to true as the searchbox will have set it to false
    const setIsSuggestionsDropdownVisible = await lazySetIsSuggestionsDropdownVisible.import();
    setIsSuggestionsDropdownVisible(true, scenarioId);

    // Set the max entries to display as the higher limit
    setMaxEntries(MAX_ENTRIES_DIRECTORY);

    // Find new suggestion set
    getSuggestions(scenarioId);
});
